import { connect } from "react-redux";
import ProjectOverview from "./Overview";
import {
  project,
  projectBudgetSummary as budgetSummary,
  projectProgressSummary as progressSummary,
  report,
  allMetrix,
  reportLoading,
  confirmedReport,
  confirmReportLoading,
  getError,
  overviewLoader,
  projectLoading,
} from "../../../store/selectors/projects.selector";
import {
  getProjectDetails,
  deleteProjectRequest,
  updateProjectRequest,
  getResourcesRequest,
  StatusReportRequest,
  clearReportRequest,
  ConfirmWsrReport,
  getMetrics,
} from "../../../store/actions/projects.actions";
import { getUsers } from "../../../store/actions/user.actions";
import { users } from "../../../store/selectors/user.selector";
import { getClients } from "../../../store/actions/clients.actions";
import { clients } from "../../../store/selectors/clients.selector";
const mapDispatchToProps = {
  getProjectDetails,
  getUsersRequest: getUsers,
  getClients,
  deleteProjectRequest,
  updateProjectRequest,
  getResourcesRequest,
  clearReportRequest,
  StatusReportRequest,
  ConfirmWsrReport,
  getMetrics,
};

const mapStateToProps = (state) => {
  const projectData = project(state);
  const projectBudgetSummary = budgetSummary(state);
  const projectProgressSummary = progressSummary(state);
  const loading = projectLoading(state);
  const overviewLoading = overviewLoader(state);
  const allUsers = users(state);
  const allclients = clients(state);
  const getReport = report(state);
  const getReportLoading = reportLoading(state);
  const getConfirmedReport = confirmedReport(state);
  const getConfirmReportLoading = confirmReportLoading(state);
  const getMetrix = allMetrix(state);
  const error = getError(state);
  return {
    projectData,
    projectBudgetSummary,
    projectProgressSummary,
    getMetrix,
    getReport,
    getReportLoading,
    getConfirmedReport,
    getConfirmReportLoading,
    allUsers,
    allclients,
    loading,
    error,
    overviewLoading,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProjectOverview);
